import {
  FormControlLabel,
  Grid,
  MenuItem,
  Modal,
  Radio,
  RadioGroup,
  Select,
  TextField,
  Typography,
} from "@mui/material";
import React, { useState } from "react";
import ModalHelper from "../Generics/ModalHelper";
import "../../assets/css/Incarico.css";
import "../../assets/css/text.css";

const tooltipContent = {
  description: {
    infoTitle: "Descrizione attività svolta",
    description:
      "Descrivi sinteticamente l'operazione, indicando le ragioni della sua importanza. Specifica esattamente il ruolo svolto dal team LEXIA.",
  },
  professionals: {
    infoTitle: "Professionisti Lexia coinvolti",
    description:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
  },
};

// Campi modificabili della Database Submission (tutti testo libero, nessuna validazione)
export const submissionFields = [
  {
    name: "description",
    label: "Descrizione attività svolta",
    multiline: true,
    maxLength: 500,
    info: tooltipContent.description,
  },
  {
    name: "professionals",
    label: "Professionisti Lexia coinvolti",
    multiline: true,
    info: tooltipContent.professionals,
  },
  { name: "counterparty", label: "Controparte" },
  { name: "counterparty_firm", label: "Studio di controparte" },
];

// Valori come li vuole il backend, etichette in italiano per l'utente
export const visibilityOptions = [
  { value: "publishable", label: "Pubblicabile" },
  { value: "confidential", label: "Confidenziale" },
];
const CONFIDENZIALITA_MAX_LENGTH = 300;

const textFieldSx = {
  "& .MuiOutlinedInput-root": {
    borderRadius: "0px",
    "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
      border: "1px solid #1b2838",
    },
  },
};

const SubmissionComponent = ({
  practice = {},
  handleSubmissionUpdate,
  errors = [],
}) => {
  const [modalObjectInfo, setModalObjectInfo] = useState(null);

  const handleChange = (name, value) => {
    let updatedSubmission = { ...practice?.submission, [name]: value };

    // Con "No" i campi di dettaglio non servono: vengono azzerati
    if (name === "richiesta_submission" && value === "No") {
      updatedSubmission = { richiesta_submission: "No" };
    }

    // Gli elementi di confidenzialità servono solo se la pratica è confidenziale
    if (name === "visibility" && value !== "confidential") {
      delete updatedSubmission.confidential_details;
    }

    const updatedPractice = {
      ...practice,
      submission: updatedSubmission,
    };

    // Il backend inoltra a Database Submission (quando l'admin segna la
    // pratica lavorata) solo se Incarico.database_submission è true:
    // il flag sta in Incarico perché è lì che il backend lo legge
    if (name === "richiesta_submission") {
      updatedPractice.Incarico = {
        ...practice?.Incarico,
        database_submission: value === "Sì",
      };
    }

    handleSubmissionUpdate(updatedPractice);
  };

  return (
    <Grid
      container
      style={{
        display: "flex",
        justifyContent: "center",
      }}
    >
      <Grid
        item
        xs={11}
        sm={10}
        style={{
          overflowY: "auto",
          marginTop: "30px",
        }}
      >
        {/* Title */}
        <Grid
          xs={12}
          spacing={4}
          item
          container
          style={{
            display: "flex",
            justifyContent: "center",
          }}
        >
          <Grid item xs={11} md={4}>
            <Typography className="color-blue-dark title-step">
              Submission
            </Typography>
          </Grid>

          <Grid item xs={11} md={4} style={{ paddingTop: "0px" }}></Grid>

          <Grid item xs={11} md={4} style={{ paddingTop: "0px" }}></Grid>
        </Grid>

        <Grid
          xs={12}
          spacing={4}
          item
          container
          sx={{
            display: "flex",
            justifyContent: { xs: "center", md: "flex-start" },
            marginBottom: "50px",
            marginTop: "2px",
          }}
        >
          {/* Box informativo + scelta Sì/No */}
          <Grid item xs={11} md={12} style={{ paddingTop: "0px" }}>
            <div
              style={{
                backgroundColor: "#d3d3d382",
                marginTop: "40px",
                padding: "20px",
                border: errors.includes("richiesta_submission")
                  ? "1px solid #bc2957"
                  : "none",
              }}
            >
              <Typography
                style={{ fontWeight: 500 }}
                className="color-blue-dark"
              >
                Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
                eiusmod tempor incididunt ut labore et dolore magna aliqua.
              </Typography>
              <Typography
                style={{ fontWeight: 500 }}
                className="color-blue-dark"
              >
                Ut enim ad minim veniam, quis nostrud exercitation ullamco
                laboris nisi ut aliquip ex ea commodo consequat.
              </Typography>

              <Typography
                style={{ marginTop: "10px", fontWeight: 500 }}
                className="color-blue-dark"
              >
                Lorem ipsum dolor sit amet?
              </Typography>

              <RadioGroup
                row
                aria-label="submission-check"
                name="richiesta_submission"
                value={practice?.submission?.richiesta_submission || ""}
                onChange={(e) => handleChange(e.target.name, e.target.value)}
              >
                <div style={{ display: "flex", flexDirection: "column" }}>
                  <FormControlLabel
                    value="Sì"
                    control={<Radio className="color-blue-dark" />}
                    label="Sì"
                  />
                  <FormControlLabel
                    value="No"
                    control={<Radio className="color-blue-dark" />}
                    label="No"
                  />
                </div>
              </RadioGroup>
            </div>
          </Grid>

          {practice?.submission?.richiesta_submission === "Sì" && (
            <>
              {submissionFields.map((field) => (
                <Grid item xs={11} md={4} key={field.name}>
                  <div
                    style={{
                      display: "flex",
                      height: "20px",
                    }}
                  >
                    <Typography className="color-blue-dark title-input">
                      {field.label}
                    </Typography>
                    {field.info && (
                      <div
                        className="icon-modal-info"
                        style={{ marginLeft: "10px", cursor: "pointer" }}
                        onClick={() => setModalObjectInfo(field.info)}
                      />
                    )}
                  </div>
                  <TextField
                    multiline={field.multiline}
                    rows={field.multiline ? 5 : undefined}
                    style={{ marginTop: "10px" }}
                    placeholder="Inserisci"
                    variant="outlined"
                    name={field.name}
                    value={practice?.submission?.[field.name] || ""}
                    onChange={(e) =>
                      handleChange(e.target.name, e.target.value)
                    }
                    inputProps={
                      field.maxLength
                        ? { maxLength: field.maxLength }
                        : undefined
                    }
                    helperText={
                      field.maxLength
                        ? `${
                            (practice?.submission?.[field.name] || "").length
                          }/${field.maxLength}`
                        : undefined
                    }
                    FormHelperTextProps={{ style: { textAlign: "right" } }}
                    fullWidth
                    sx={textFieldSx}
                    InputProps={{
                      style: {
                        color: "#1b2838",
                      },
                    }}
                  />
                </Grid>
              ))}

              {/* Visibilità operazione */}
              <Grid item xs={11} md={4}>
                <div
                  style={{
                    display: "flex",
                    height: "20px",
                  }}
                >
                  <Typography className="color-blue-dark title-input">
                    Visibilità operazione
                  </Typography>
                </div>
                <Select
                  value={practice?.submission?.visibility || ""}
                  onChange={(e) => handleChange("visibility", e.target.value)}
                  displayEmpty
                  fullWidth
                  style={{ marginTop: "10px" }}
                >
                  <MenuItem value="">
                    <span style={{ color: "#abb0b6" }}>Seleziona</span>
                  </MenuItem>
                  {visibilityOptions.map((option) => (
                    <MenuItem key={option.value} value={option.value}>
                      {option.label}
                    </MenuItem>
                  ))}
                </Select>
              </Grid>

              {practice?.submission?.visibility === "confidential" && (
                <Grid item xs={11} md={4}>
                  <div
                    style={{
                      display: "flex",
                      height: "20px",
                    }}
                  >
                    <Typography className="color-blue-dark title-input">
                      Elementi di confidenzialità
                    </Typography>
                  </div>
                  <TextField
                    multiline
                    rows={5}
                    style={{ marginTop: "10px" }}
                    placeholder="Descrivi gli elementi confidenziali..."
                    variant="outlined"
                    name="confidential_details"
                    value={practice?.submission?.confidential_details || ""}
                    onChange={(e) =>
                      handleChange(e.target.name, e.target.value)
                    }
                    inputProps={{ maxLength: CONFIDENZIALITA_MAX_LENGTH }}
                    helperText={`${
                      (practice?.submission?.confidential_details || "")
                        .length
                    }/${CONFIDENZIALITA_MAX_LENGTH}`}
                    FormHelperTextProps={{ style: { textAlign: "right" } }}
                    fullWidth
                    sx={textFieldSx}
                    InputProps={{
                      style: {
                        color: "#1b2838",
                      },
                    }}
                  />
                </Grid>
              )}
            </>
          )}
        </Grid>
      </Grid>

      <Modal open={!!modalObjectInfo} onClose={() => setModalObjectInfo(null)}>
        <div>
          {modalObjectInfo && (
            <ModalHelper
              onClose={() => setModalObjectInfo(null)}
              modalObjectInfo={modalObjectInfo}
            />
          )}
        </div>
      </Modal>
    </Grid>
  );
};

export default SubmissionComponent;
